// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defineHorizonElement = (tagName, klass) => {
    if (!customElements.get(tagName)) {
        customElements.define(tagName, class extends klass {
        });
    }
};
//# sourceMappingURL=define-horizon-element.js.map